import React from 'react';
import memoize from 'memoize-one';
import { BasicActionBtns } from '../../../components';

const columns = memoize(clickHandler => [
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: 2
  },
  {
    name: 'CUPOS DISPONIBLES',
    selector: 'vacancies',
    sortable: true,
    center: true,
    grow: 1
  },
  {
    name: 'MODALIDAD',
    selector: 'translatedRemote',
    sortable: true,
    center: true,
    grow: 1
  },
  {
    name: 'NIVEL',
    selector: 'translatedExpertiseLevel',
    sortable: true,
    center: true,
    grow: 1
  },
  {
    name: 'TIPO DE JORNADA',
    selector: 'translatedWorkSchedule',
    sortable: true,
    center: true,
    grow: 1
  },
  {
    name: 'ACCIONES',
    cell: item => {
      console.log('Item:', item);
      return (
        <BasicActionBtns
          item={item}
          resource="SelectionProcess"
          clickHandler={clickHandler}
          withShow
          withEdit={false}
          withDestroy={false}
        />
      );
    },
    ignoreRowClick: true,
    allowOverflow: false,
    grow: 0.7,
    center: true
  }
]);

export default columns;
